var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _setup.isReadonly
        ? _c(
            "div",
            { staticClass: "mb-2" },
            [
              _c("span", [_vm._v("Preview")]),
              _vm._v(" "),
              _c(_setup.LayersHeaderListPreview),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        _setup.CResizable,
        {
          staticClass: "layers-container",
          scopedSlots: _vm._u([
            {
              key: "header",
              fn: function () {
                return [
                  _c(_setup.LayersHeader, {
                    attrs: {
                      "start-with-canva": _setup.startWithCanva,
                      title: _vm.settings.title,
                    },
                    on: {
                      "import-layers": _setup.importLayers,
                      "user-updated": () => _setup.emit("user-updated"),
                      "open-find-layers": _setup.openFindLayers,
                    },
                  }),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._v(" "),
          _c(_setup.FindInLayers, {
            ref: "findInLayersRef",
            attrs: { enable: _setup.enableFindInLayers },
            on: { "layer-selected": _setup.setActiveElement },
          }),
          _vm._v(" "),
          _c(_setup.LayersTree, {
            staticClass: "layers-tree",
            on: { "tree-item-moved": _setup.layerTreeItemMove },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }